var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24504 10.6667H21.9117V13.3333H24.5784V5.33333C24.5784 3.86667 23.3784 2.66667 21.9117 2.66667H20.5784V0H17.9117V2.66667H7.24504V0H4.57837V2.66667H3.24504C1.76504 2.66667 0.591702 3.86667 0.591702 5.33333L0.578369 24C0.578369 25.4667 1.76504 26.6667 3.24504 26.6667H12.5784V24H3.24504V10.6667ZM3.24504 5.33333H21.9117V8H3.24504V5.33333ZM27.0317 19.04L26.085 19.9867L23.2584 17.16L24.205 16.2133C24.725 15.6933 25.565 15.6933 26.085 16.2133L27.0317 17.16C27.5517 17.68 27.5517 18.52 27.0317 19.04ZM22.3117 18.1067L25.1384 20.9333L18.0717 28H15.245V25.1733L22.3117 18.1067Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.0a4f18f0.svg";
export { ForwardRef as ReactComponent };